// NOTE: THIS FORM WILL NOT WORK WITH WI OR ORRI OWNERSHIPS UNLESS FORM FIELDS ARE UPDATED TO REPRESENT IT. 
// KEEP IN MIND IF THAT LOGIC EVER CHANGES.
import * as React from 'react';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';

export interface IAdditionalOwnerSelectionProps {
    onChange?: (id: number) => void;
    onChangeNpri?: (status: string) => void;
    revertNpri: () => void;
}

export type IAdditionalOwnerSelectionStateProps = {
    namePrefix: string;
};

type IAdditionalOwnerSelectionState = {
    isNpri: boolean;
};

type IAdditionalOwnerSelectionPageProps = IAdditionalOwnerSelectionProps & IAdditionalOwnerSelectionStateProps;

class AdditionalOwnerSelection extends React.Component<IAdditionalOwnerSelectionPageProps, IAdditionalOwnerSelectionState> {
    constructor(props: IAdditionalOwnerSelectionPageProps) {
        super(props);

        this.state = {
            isNpri: false
        };
    }

    onChangeAddlOwnerType = (value: number) => {
        let isNpri = value === 4;
        this.setState({ isNpri: isNpri });
        if (!isNpri) {
            this.props.revertNpri();
        }

        this.props.onChange?.(value);
    };

    render() {
        return (
            <>
                <FormSelect
                    name={`${this.props.namePrefix}additionalOwnershipTypeId`}
                    label="Additional Ownership Type"
                    items={[
                        new SelectItem(1, 'HEIR'),
                        new SelectItem(2, 'REMAINDERMAN'),
                        new SelectItem(3, 'NON-EXECUTIVE'),
                        new SelectItem(4, 'NON-PARTICIPATING'),
                        new SelectItem(5, 'TRANSFER ON DEATH'),
                        new SelectItem(6, 'NAKED OWNER'),
                    ]}
                    className="lh-half-width"
                    onChange={(id: number | string) => this.onChangeAddlOwnerType(id as number)}
                    isRequired={true}
                />
                {this.state.isNpri && (
                    <FormSelect
                        name={`${this.props.namePrefix}npriStatus`}
                        label="NPRI Type"
                        items={[
                            new SelectItem('Fixed', 'Fixed'),
                            new SelectItem('Floating', 'Floating')
                        ]}
                        className="lh-half-width"
                        onChange={(status: number | string) => this.props.onChangeNpri?.(status as string)}
                    />
                )}
            </>
        );
    }
}

export default AdditionalOwnerSelection;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AdditionalOwnerSelection.tsx